module.exports = __webpack_public_path__ + "img/l-02.31058d7c.png";